<template>
  <v-btn
    class="edit-btn mb-2"
    outlined
    fab
    tile
    x-small
    color="blue"
    @click="clickButton"
  >
    <v-icon dark>mdi-square-edit-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  methods: {
    clickButton() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-btn {
  border-radius: 4px;
  border-color: #E2E6EA;
}
</style>
